import { compareBigintSafe } from "../functions/Misc.function";
import { isEqual } from "lodash";

export type JsonPrimType = BigInt | bigint | Date | string | number | boolean | null | object;
export type JsonObject = { [key: string]: JsonObject | JsonPrimType };
export type JsonTypes = JsonObject | JsonPrimType | Array<JsonObject> | Array<JsonPrimType>;

export class JsonHelper {
  static stringify(value: JsonTypes, space?: number | string): string {
    return JSON.stringify(value, (_, x) => (typeof x === "bigint" ? x.toString() : x), space);
  }

  static parse(value: string): JsonTypes {
    return JSON.parse(value);
  }

  static tryParse<T = JsonTypes>(value: string, throwIfAnErrorOccurred = false): T | undefined {
    try {
      return (JsonHelper.parse(value) as unknown) as T;
    } catch (e) {
      if (throwIfAnErrorOccurred) {
        throw e;
      }

      return undefined;
    }
  }

  static diff<T = JsonTypes>(original: T, target: T, normalizeJson?: (data: T) => T): Partial<T> {
    const originalJson = normalizeJson ? normalizeJson(original) : original;
    const targetJson = normalizeJson ? normalizeJson(target) : target;

    return Object.keys(targetJson).reduce((prev, currentKey) => {
      const key = currentKey as keyof T;

      const isEqualBigint =
        [typeof originalJson[key], typeof targetJson[key]].includes("bigint") && compareBigintSafe(targetJson[key], originalJson[key]);
      const isEqualValue = isEqual(targetJson[key], originalJson[key]);

      if (isEqualBigint || isEqualValue) return prev;

      return { ...prev, [key]: target[key] };
    }, {} as Partial<T>);
  }
}
